import * as React from 'react';
import { FelaComponent } from 'react-fela';
import { TextSample } from './TextSample';
import { headerText, longText, shortText } from './TextSpecimen';
const Container = ({ children }) => {
    const style = {
        maxWidth: 650,
    };
    return React.createElement(FelaComponent, { style: style }, children);
};
export const FontMixContent = ({ textFont, headlineFont, fontSizes, textFontSize }) => {
    const extendedHeadline1Font = {
        ...headlineFont,
        fontSize: fontSizes.length > 0 ? fontSizes[0] : '30px',
    };
    const extendedHeadline2Font = {
        ...headlineFont,
        fontSize: fontSizes.length > 1 ? fontSizes[1] : '24px',
    };
    const extendedHeadline3Font = {
        ...headlineFont,
        fontSize: fontSizes.length > 2 ? fontSizes[2] : '18px',
    };
    const extendedTextFont = {
        ...textFont,
        fontSize: textFontSize ? textFontSize : '14px',
    };
    return (React.createElement(Container, null,
        React.createElement(TextSample, { fontStyles: extendedHeadline1Font, as: "h1" }, headerText),
        React.createElement(TextSample, { fontStyles: extendedTextFont }, longText),
        React.createElement(TextSample, { fontStyles: extendedHeadline2Font, as: "h2" }, headerText),
        React.createElement(TextSample, { fontStyles: extendedTextFont }, shortText),
        React.createElement(TextSample, { fontStyles: extendedHeadline3Font, as: "h3" }, headerText),
        React.createElement(TextSample, { fontStyles: extendedTextFont }, longText),
        React.createElement(TextSample, { fontStyles: extendedHeadline3Font, as: "h3" }, headerText),
        React.createElement(TextSample, { fontStyles: extendedTextFont }, shortText),
        React.createElement(TextSample, { fontStyles: extendedHeadline2Font, as: "h2" }, headerText),
        React.createElement(TextSample, { fontStyles: extendedTextFont }, longText),
        React.createElement(TextSample, { fontStyles: extendedHeadline1Font, as: "h1" }, headerText),
        React.createElement(TextSample, { fontStyles: extendedTextFont }, shortText)));
};
//# sourceMappingURL=FontMixContent.js.map